import React from "react";
import Categoriproduct from "../components/ui/Categoriproduct";

const Softdrinks = () => {
  return (
    <div>
      <Categoriproduct />
    </div>
  );
};

export default Softdrinks;
